export const ACCESS_TOKEN: string = "authToken";
export const REFRESH_TOKEN: string = "refreshToken";
